<template>
  <f7-page name="device-config" ref="page">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('DeviceConfig') }}</f7-nav-title>
      <f7-nav-right>

      </f7-nav-right>
    </f7-navbar>

    <f7-block>
      <p>{{$t('ConfigDeviceDescription')}}</p>
    </f7-block>

    <f7-list>
      <f7-list-item :title="$t('ConfigInputs')" link="/assets/device-config/inputs/">
        <template #media>
          <f7-icon icon="f7-icons text-color-lightgray icon-live-input"></f7-icon>
        </template>
      </f7-list-item>
      <f7-list-item :title="$t('ConfigVoltageAlarms')" link="/assets/device-config/power/">
        <template #media>
          <f7-icon icon="f7-icons text-color-lightgray icon-live-battery"></f7-icon>
        </template>
      </f7-list-item>


    </f7-list>
  </f7-page>
</template>

<script>
export default {
  name: "device-config"
}
</script>

<style scoped>

</style>